
import { computed, defineComponent } from "vue";
import { RouterName } from "@/models/common";
import { useI18n } from "vue-i18n";
import router from "@/router";

export default defineComponent({
  name: "Main Nav",
  setup() {
    const activeRoute = computed(() => {
      return router.currentRoute.value.path;
    });

    const { t } = useI18n({ useScope: "global" });

    const isActive = (item: string) => {
      if (item === "/") {
        if (activeRoute.value.toLowerCase().toString() === item) return true;
      } else
        return activeRoute.value
          .toLowerCase()
          .toString()
          .startsWith(item.toLowerCase());
    };

    const t2 = (key: string) => {
      switch (key) {
        case RouterName.ONLINE_CARE:
          return t("face-to-face cooperation");
        case RouterName.SECOND_OPINION:
          return t("second opinion");
        default:
          return "";
      }
    };

    return {
      RouterName,
      isActive,
      activeRoute,
      t,
      t2,
    };
  },
});
